import {Box, Button, Checkbox, Drawer, Grid, IconButton, Slide, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {CloseOutlined, ShoppingBagOutlined} from '@mui/icons-material'
import {useFuncionesCarritoLateral} from "./useFuncionesCarritoLateral";
import Tarjetas_Producto_Lateral from "../Tarjetas/Tarjetas_Producto_Lateral";
import {obtenerValorTotal} from "../../Modulo_Envios_2026/Funciones/obtenerValorTotal";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

export const useCarritoLateral = () => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();
    const {productos} = useFuncionesCarritoLateral()
    const [open, setOpen] = useState(false);
    const [acepto, setAacepto] = useState(true);

    const abrir = () => {
        setOpen(true);
    }

    const cerrar = () => {
        setOpen(false);
    }



    const Carrito = () => {

        return (<Drawer
            open={open}
            anchor={'right'}
            onClose={() => setOpen(false)}
            sx={{
                width: sCell ? 370 : 500
            }}
            slotProps={{
                paper: {
                    sx: {
                        width: sCell ? 370 : 500,
                        backgroundColor: 'transparent', // Para que no se vea el fondo sólido mientras hace fade
                        boxShadow: 'none',
                    }
                }
            }}


        >

            <Slide direction={'left'} in={open} timeout={500}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: 'background.paper',
                }}>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{
                                  justifyContent: 'space-between',
                                  textAlign: 'center',
                                  px: 3,
                                  py: 2,
                                  borderBottom: 1,
                                  borderColor: '#00000050',
                                  minHeight: sCell ? '6vh' : '8vh'
                              }}>
                            <Typography sx={{fontWeight: 400}}>CARRITO
                                <span
                                    style={{
                                        backgroundColor: '#000',
                                        fontWeight: 400,
                                        color: '#fff',
                                        borderRadius: 20,
                                        padding: 4,
                                        paddingRight: 6,
                                        marginLeft: 5,
                                        fontSize: 12,
                                        marginTop: -4,
                                        marginBottom: 5
                                    }}> {productos.length}</span>
                            </Typography>

                            <IconButton
                                onClick={() => setOpen(false)}
                                sx={{p: 0}}>
                                <CloseOutlined/>
                            </IconButton>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{
                                height: '65vh',
                                px: 3,
                                overflowY: 'scroll',
                            }}
                        >

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                                {productos && productos.length > 0 ?


                                    productos.map((it, index) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjetas_Producto_Lateral item={it} cerrar={cerrar}/>
                                        </Grid>
                                    ))


                                    :

                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{mt: 25, px: 4}}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                            <ShoppingBagOutlined sx={{width: 52, height: 52}}/>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                            <Typography sx={{fontSize: 32, fontWeight: 600}}>Tu carrito está
                                                vacío</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                            <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: 'center'}}>
                                                Explora nuestras categorías cuidadosamente seleccionadas para descubrir
                                                las
                                                piezas perfectas para tu guardarropa.
                                            </Typography>
                                        </Grid>

                                    </Grid>


                                }
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{
                                height: '23vh',
                                borderTop: 1,
                                borderColor: '#00000010',
                                py: 2,
                                px: 3
                            }}
                        >

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontWeight: 600}}>Subtotal</Typography>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                                    <Typography
                                        sx={{fontSize: 16}}>{formatoMoneda(obtenerValorTotal(productos))}</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2, color: '#00000050'}}>
                                    <Typography sx={{fontWeight: 400, fontSize: 12, lineHeight: 1.2}}>Impuesto incluido.
                                        Los gastos de
                                        envío
                                        se calculan en la pantalla de pago.</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1.5}}>
                                    <Typography sx={{fontSize: 12, lineHeight: 1.1}}>
                                        <Checkbox sx={{mt: 0, mb: 0, p: 0}} checked={acepto}
                                                  onChange={() => setAacepto(!acepto)}/> Estoy de acuerdo con los
                                        términos y condiciones
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2.5}}>
                                    <Button
                                        disabled={!acepto}
                                        onClick={() => {
                                            setOpen(false);
                                            navigate('/Checkout')
                                        }}
                                        fullWidth sx={{pb: 1.5, pt: 1.4}}>Pagar Pedido</Button>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Slide>


        </Drawer>)
    }

    return {
        Carrito,
        abrir,
        productos
    }
}